import React, { Component } from 'react';
import store from '../../../store/store';
import { TransactionTableStyledMemory } from '../../BaseComponent/memory';
import AddProductContext from './AddProductContext';
import { addProduct } from '../../Products/reducer/productSlice';

/**
 * @param startPage always should be 0 when it comes to 1st page since react-pagination require 1st page to be index = 0
 */

class AddProductProvider extends TransactionTableStyledMemory {
  primaryMemory = {};

  state = {
    // jwtToken: '',
    // clientToken: '',
    // userData: '',
    primaryMemory: this.primaryMemory,
    sku: "",
    name: "",
    description: "",
    images: [],
    customer_price: 0,
    walk_in_customer_price: 0,
    tags: [],
    category: "",
    subCategory: "",
    brand: "",
    stock: "",
    status: true,
    isFeatured: "",
  };

  prevState = [];

  setJwtToken = (jwtToken) => {
    if (jwtToken !== this.state.jwtToken) {
      this.setState({
        ...this.state,
        jwtToken,
      });
    }
  };

  setUserToken = (clientToken) => {
    if (clientToken !== this.state.clientToken) {
      this.setState({
        ...this.state,
        clientToken,
      });
    }
  };

  addNewProduct = ({ ...options }) => {
    const convState = {
      // ...this.state,
      sku: options.sku,
      name: options.productName,
      description: options.description,
      images: options.productImages,
      customer_price: options.wholesalePrice,
      walk_in_customer_price: options.retailPrice,
      tags:  options.tags,
      userTags:  options.customTags,
      category: options.category,
      subCategory: options.subCategory,
      brand: options.brand,
      stock: options.quantity,
      status: true,
      isFeatured: options.isFeatured,
    };
    

    console.log('convState', convState)

    this.makeDispatch(convState);
  };

  makeDispatch = async ({ ...options }) => {
    return store.dispatch(addProduct(options));
  };

  render() {
    const contextValue = {
      jwtToken: this.state.jwtToken,
      setJwtToken: this.setJwtToken,
      addNewProduct: this.addNewProduct,
      setUserToken: this.setUserToken,
      clientToken: this.state.clientToken,
      primaryMemory: this.state.primaryMemory,
    };

    return <AddProductContext.Provider value={contextValue}>{this.props.children}</AddProductContext.Provider>;
  }
}

export default AddProductProvider;
